import { Button } from "react-bootstrap";

function LoadButton({ handler, disabled }) {
  return (
    <Button
      disabled={disabled}
      className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-15 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
      type="submit"
      variant="warning"
      onClick={handler}
    >
      {disabled ? (
        <div>
          <i className="fa fa-circle-notch fa-spin"></i>{" "}
        </div>
      ) : (
        <div>
          <span>Load</span>
        </div>
      )}
    </Button>
  );
}

export default LoadButton;
